import {
  ApplicationConfig,
  importProvidersFrom,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';

import { routes } from './app.routes';
import { environment } from '../environments/environment';
import { provideCeiHttpClient, provideCeiHttpErrorHandling } from '@cei-ufg/ngx-arquitetura-cei-frontend';
import { provideCeiSsoBootstrap, runtimeConfig } from '@cei-ufg/ngx-cei-sso-client';
import { credenciaisMapper } from './constants/credenciais-mapper';
import { NgxTurnstileModule } from 'ngx-turnstile';

export { runtimeConfig };

export const appConfig: ApplicationConfig = {
  providers: [
    provideCeiHttpErrorHandling({
      redirectApiForbidden: false,
      redirectUnauthenticated: false,
    }),
    provideCeiHttpClient(),
    provideBrowserGlobalErrorListeners(),
    provideAnimationsAsync(),
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideClientHydration(withEventReplay()),
    provideCeiSsoBootstrap({
      environment,
      credenciaisPayload: credenciaisMapper,
      skipSessionBoot: true,
    }),
    importProvidersFrom(NgxTurnstileModule),
  ],
};
